import apiClient from "../api/client";

export const AuthService = {
  async login(email: string, password: string) {
    const response = await apiClient.post("/auth/login/", { email, password });
    return response;
  },

  async register(userData: any) {
    const response = await apiClient.post("/auth/register/", userData);
    return response;
  },

  async getMe() {
    const response = await apiClient.get("/auth/users/me/");
    return response;
  },

  async changePassword(data: {
    current_password: string;
    new_password: string;
    confirm_password: string;
  }) {
    const response = await apiClient.post("/auth/change_password/", data);
    return response;
  },

  async refreshToken(refresh: string) {
    const response = await apiClient.post("/auth/token/refresh/", { refresh });
    return response;
  },

  async updateProfile(data: any) {
    const response = await apiClient.patch("/auth/users/update_profile/", data);
    return response;
  },
};
